import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import {Config} from '../utils/Config';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

class CancelTicket extends Component {
  constructor(props) {
    super(props);
    const {bookingId, email} = this.props.match.params;

    this.state = {
      isSnackBarOpen: false,
      isLoading: false,
      isSuccess: false,
      bookingId: bookingId ? bookingId : '',
      email: email ? email : '',
    };
  }

  componentDidMount() {
    const {bookingId, email, provider} = this.props.match.params;
    if (bookingId && email && provider) {
      this.handleClick();
    }
  }

  handleClick = () => {
    console.log('Cancel Ticket');
    const {bookingId, email} = this.state;
    if (!this.props.match.params.bookingId && !this.props.match.params.email) {
      if (!bookingId) {
        this.updateStateObj(true, 'bookingId', 'Please Enter BookingID');
        return;
      }
      if (!this.verifyEmail(email)) {
        this.updateStateObj(true, 'Email', 'Please Enter Valid Email');
        return;
      }
    }

    this.setState({
      isLoading: true,
    });

    //getting Provider
    const getproviderURL = `${Config.SECURED_API_HOST}/api/platform/bus/getprovider?bookingId=${bookingId}`;
    fetch(getproviderURL)
      .then((res) => res.json())
      .then((res) => {
        console.log(res);

        if (res.Error === null) {
          let provider = '';
          if (res.Provider === 'APSRTC') {
            provider = '&provider=apsrtc';
          }

          //getting ticket details
          const ticketdetailsURL = `${Config.SECURED_API_HOST}/api/platform/bus/ticket?bookingid=${bookingId}&email=${email}${provider}`;
          fetch(ticketdetailsURL)
            .then((res) => res.json())
            .then((res) => {
              console.log(res);
              if (res.Error === null) {
                if (res.status !== 'CANCELLED') {
                  this.setState({
                    passenger: res.inventoryItems,
                    provider,
                  });
                  this.cancelTicketdeatils(provider);
                } else {
                  throw new Error('Ticket has been already Cancelled');
                }
              } else {
                throw res.Error;
              }
            })
            .catch((error) => {
              console.log(error);
              this.setState({isLoading: false});
              this.openSnackBar(error.message ? error.message : error);
            });
        } else {
          throw res.Error;
        }
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        console.log(error);
        this.openSnackBar('Something Went worng ! Please Try Again' + error);
      });
  };

  cancelTicketdeatils = (provider) => {
    const cancelticketdetailsURL = `${Config.SECURED_API_HOST}/api/platform/bus/cancelticketdetails?bookingid=${this.state.bookingId}&email=${this.state.email}${provider}`;
    fetch(cancelticketdetailsURL)
      .then((res) => res.json())
      .then((res) => {
        let cancellationCharges = 0;
        let fares = 0;
        let seatToCancel = {};

        if (
          Object.keys(res.cancellationCharges).length === 0 &&
          Object.keys(res.cancellationCharges).length === 0
        ) {
          this.openSnackBar('Cancellation data Not found ');
          return;
        }
        for (const key in res.cancellationCharges) {
          cancellationCharges += res.cancellationCharges[key];
          seatToCancel[key] = true;
        }

        for (const key in res.fares) {
          fares += res.fares[key];
        }

        this.setState({
          cancelTicketdeatils: res,
          cancellationCharges,
          fares,
          seatToCancel,
          isDialogOpen: true,
          isLoading: false,
        });
        console.log(res);
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        console.log(error);
        this.openSnackBar('Something Went worng ! Please Try Again');
      });
  };

  handleConfirmation = () => {
    console.log('Cancelling....');
    const {seatToCancel, email, bookingId, provider} = this.state;
    let seats = [];

    if (Object.keys(seatToCancel).every((k) => !seatToCancel[k])) {
      return this.openSnackBar('Please Select Atleast one Seat');
    }
    this.setState({isLoading: true});
    Object.keys(seatToCancel).forEach((s) => {
      if (seatToCancel[s]) seats.push(s);
    });
    // console.log(seats.join());
    // console.log(seatToCancel);

    const cancelTicketURL = `${
      Config.SECURED_API_HOST
    }/api/platform/bus/cancelticket?bookingid=${bookingId}&seatstocancel=${seats.join()}&email=${email}${provider}`;
    fetch(cancelTicketURL)
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          this.setState({
            isSuccess: true,
            isLoading: false,
            canceldata: res,
            isDialogOpen: false,
          });
        } else {
          this.setState({isLoading: false});
          this.openSnackBar('Something Went Wrong! Please try again');
        }
        console.log(res);
      })
      .catch((error) => {
        this.setState({isLoading: false});
        console.log(error);
        this.openSnackBar('Something Went Wrong! Please try again');
      });
  };

  openSnackBar = (message) => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({isSnackBarOpen: true, message: msg});
  };

  handleClose = () => {
    this.setState({isSnackBarOpen: false});
  };

  verifyEmail = (email) => {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) return true;
    return false;
  };

  updateStateObj = (flag, name, message) => {
    this.setState({
      [`${name}Err`]: flag,
      [`${name}ErrTxt`]: message,
    });
  };

  handleChange = (type, key) => (event) => {
    let {
      seatToCancel,
      fares,
      cancellationCharges,
      cancelTicketdeatils,
    } = this.state;
    if (type === 'bookingId') {
      this.setState({
        bookingId: event.target.value,
      });
      this.updateStateObj(false, 'bookingId', '');
    } else if (type === 'email') {
      if (this.verifyEmail(event.target.value)) {
        this.updateStateObj(false, 'Email', '');
      } else {
        this.updateStateObj(true, 'Email', 'Please Enter Valid Email');
      }
      this.setState({
        email: event.target.value,
      });
    } else if (type === 'passenger') {
      seatToCancel[key] = !seatToCancel[key];
      if (!seatToCancel[key]) {
        fares -= cancelTicketdeatils.fares[key];
        cancellationCharges -= cancelTicketdeatils.cancellationCharges[key];
      } else {
        fares += cancelTicketdeatils.fares[key];
        cancellationCharges += cancelTicketdeatils.cancellationCharges[key];
      }

      this.setState({
        seatToCancel,
        fares,
        cancellationCharges,
      });
    }
  };

  handleDialogClose = () => {
    this.setState({
      isDialogOpen: false,
    });
  };

  render() {
    const {
      bookingId,
      email,
      cancellationCharges,
      fares,
      passenger,
      isDialogOpen,
      canceldata,
    } = this.state;

    const header = (
      <div className="header">
        <Grid container justifyContent="flex-start" className="from-to">
          <Grid
            item
            xs={1}
            className="backBtn"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <i className="material-icons">arrow_back</i>
          </Grid>
          <Grid item xs={10}>
            <div className="title">
              <span> Cancel Ticket</span>
            </div>
          </Grid>
        </Grid>
      </div>
    );

    const InputFields = (
      <div className="container">
        <TextField
          label="BookingId"
          fullWidth
          type="text"
          name="text"
          InputLabelProps={{style: {fontSize: 14}}}
          margin="normal"
          error={this.state.bookingIdErr ? this.state.bookingIdErr : false}
          helperText={
            this.state.bookingIdErrTxt ? this.state.bookingIdErrTxt : ''
          }
          value={bookingId ? bookingId : ''}
          onChange={this.handleChange('bookingId')}
        />
        <TextField
          label="Email"
          type="email"
          name="email"
          fullWidth
          value={email ? email : ''}
          InputLabelProps={{style: {fontSize: 14}}}
          autoComplete="email"
          error={this.state.EmailErr ? this.state.EmailErr : false}
          helperText={this.state.EmailErrTxt ? this.state.EmailErrTxt : ''}
          onChange={this.handleChange('email')}
          margin="normal"
        />
        <div style={{textAlign: 'center', margin: '10px'}}>
          <button
            className="btn btn-success"
            onClick={this.handleClick}
            style={{fontSize: '14px'}}
          >
            Cancel Ticket
          </button>
        </div>
      </div>
    );

    let passengerdata = isDialogOpen
      ? Object.keys(passenger).map((key) => {
          let seat = passenger[key].seatName;
          return (
            <div key={key}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.seatToCancel[seat]}
                    onChange={this.handleChange(`passenger`, seat)}
                    value="antoine"
                  />
                }
                style={{margin: '0px'}}
                label=""
              />
              {passenger[key].passenger.name + ' SeatName: ' + seat}
            </div>
          );
        })
      : '';

    const CancelTicket = isDialogOpen ? (
      <div className="cancel-ticket">
        <h3>Cancellation Details</h3>
        <hr />
        <h4>Select Passenger to Cancel</h4>
        {passengerdata}
        <Grid className="content">
          <Grid container>
            <Grid item xs={7}>
              <span>Cancellation Charges</span>
            </Grid>
            <Grid item xs={5}>
              Rs {cancellationCharges}
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={7}>
              <span>Total Refund Amount</span>
            </Grid>
            <Grid item xs={5}>
              Rs {fares}
            </Grid>
          </Grid>
          <Grid item xs={12} className="text-right">
            <button
              style={{fontSize: '14px'}}
              className="btn btn-default"
              onClick={this.handleDialogClose}
            >
              Cancel
            </button>
            <button
              style={{fontSize: '14px'}}
              className="btn btn-danger"
              onClick={this.handleConfirmation}
            >
              Confirm
            </button>
          </Grid>
        </Grid>
      </div>
    ) : (
      ''
    );

    //partial apsrtc
    // NewPNR: 94978518
    // cancelled_seats: "28"
    // message: "Your ticket is successfully cancelled"
    // return_amount: 36
    // status: "success"
    // totalcancel_seatsfare: 64

    // redbus
    // {"tin":"C479X387","refundAmount":314.0,"cancellationCharge":0.0,"Error":null}

    const successMsg = canceldata ? (
      this.props.match.params.provider === 'APSRTC' ? (
        <div className="cancel-ticket">
          <h3>Cancellation Details</h3>
          <hr />
          <Grid className="content">
            <h4>{canceldata.message}</h4>
            <Grid container>
              <Grid item xs={7}>
                <span>Total Refund Amount</span>
              </Grid>
              <Grid item xs={5}>
                Rs {canceldata.return_amount}
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div className="cancel-ticket">
          <h3>Cancellation Details</h3>
          <hr />
          <Grid className="content">
            <h4>Ticket was Cancelled Successfully!</h4>
            <Grid container>
              <Grid item xs={7}>
                <span>Total Refund Amount</span>
              </Grid>
              <Grid item xs={5}>
                Rs {canceldata.refundAmount}
              </Grid>
            </Grid>
          </Grid>
        </div>
      )
    ) : (
      ''
    );

    return (
      <div style={{padding: '0px'}}>
        {header}
        {InputFields}

        {this.state.isLoading ? (
          <div className="loading fixed">
            <CircularProgress />
          </div>
        ) : (
          ''
        )}
        {CancelTicket}
        {this.state.isSuccess ? successMsg : ''}
        <Snackbar
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={5000}
          message={this.state.message}
        />
      </div>
    );
  }
}

export default CancelTicket;
